import React, { useState } from 'react';
import { Icon } from '..';
import './accordion-item.scss';
export var AccordionItem = function (_a) {
    var heading = _a.heading, count = _a.count, mb = _a.mb, extendClass = _a.extendClass, children = _a.children;
    var _b = useState(false), active = _b[0], setActive = _b[1];
    var AccordionItemClasses = 'c-accordion-item';
    if (active) {
        AccordionItemClasses += ' isActive';
    }
    if (mb) {
        AccordionItemClasses += " u-mb-".concat(mb);
    }
    var handleToggle = function () {
        setActive(!active);
    };
    return (React.createElement("section", { "data-testid": "accordion-item", className: AccordionItemClasses },
        React.createElement("header", null,
            React.createElement("h3", null,
                React.createElement("button", { onClick: handleToggle, className: "c-accordion-item__btn" },
                    React.createElement("span", null, heading),
                    React.createElement(Icon, { name: "chevronDown" }),
                    count && React.createElement("span", null, count)),
                React.createElement("span", { className: "c-accordion-item__header" }, heading))),
        React.createElement("div", { className: "c-accordion-item__body ".concat(extendClass !== null && extendClass !== void 0 ? extendClass : '') }, children)));
};
